let cursos = [
    
    {
        slug: 'cuidado-integral',
        inscricao:'https://portal.multiversa.com/inscricao-pos',
        name: 'Cuidado Integral',
        listar: false,
        img: '/cursos/cuidado-integral.jpg',
        area: 'Artes e Humanidades',  
        categoria:'Pós-graduação',
        meta_tags:'educação, pós-graduação, gestão universitária, cuidado pessoal, cuidado integral, terapia, terapêutica, holística, foz do iguaçu, distrito federal, brasília, multiversa, neoperspectiva',
        description_seo: "Em parceria com a UNIPAZDF – Universidade Internacional da Paz lançamos essa especialização, buscando oferecer oportunidade nesse momento pós pandemia de Cuidar de quem Cuida, de forma ampla e sistêmica.",
        // competencias: [
        //     'Inteligência emocional',
        //     'Relacionamento intra e interpessoal',
        //     'Visão transdisciplinar e sistêmica',
        //     'Inteligência cuidadora- aprendedora-educador'
        // ],
        data_inicio: "27",
        mes_inicio: "fevereiro",
        ano_inicio: "2023",
        modalidade: 'Online',
        video: '',
        cards: [
            {
                icon:'fas fa-brain',
                title: 'Inteligência emocional',
                description: ''
            },
            {
                icon:'fas fa-arrows-to-eye',
                title: 'Visão transdisciplinar e sistêmica',
                description: ''
            },
            {
                icon:'fas fa-arrows-spin',
                title: 'Abordagem holística',
                description: ''
            },
            {
                icon:'fas fa-people-arrows',
                title: 'Relacionamento intra e interpessoal',
                description: ''
            },
            {
                icon:'fas fa-hand-holding-heart',
                title: 'Inteligência cuidadora-aprendedora-educador',
                description: ''
            },
        ],
        turmas: [
            { inicio: "27 de fevereiro de 2023", horario: "19 as 21h"},
        ],
        months: [
            {
                dates1: ["2023-02-27"],
            },
            {
                dates1: ["2023-03-06", "2023-03-13", "2023-03-20", "2023-03-27"],
            },
            {
                dates1: ["2023-04-03", "2023-04-10", "2023-04-17", "2023-04-24"],
            },
            {
                dates1: ["2023-05-08", "2023-05-15", "2023-05-22", "2023-05-29"],
            },
            {
                dates1: ["2023-06-05", "2023-06-19","2023-06-12", "2023-06-26"],
            },
            {
                dates1: ["2023-07-03"],
            },
            {
                dates1: ["2023-08-07", "2023-08-14", "2023-08-21", "2023-08-28"],
            },
            {
                dates1: ["2023-09-04", "2023-09-11", "2023-09-18", "2023-09-25"],
            },
            {
                dates1: ["2023-10-02", "2023-10-09", "2023-10-16", "2023-10-23"],
            },
            {
                dates1: ["2023-11-01", "2023-11-02", "2023-11-03", "2023-11-04", "2023-11-05"],
            },
        ],
        carga_horaria: '<p class="my-0">360 horas</p>',
        duracao: "13 meses",
        descricao: '<p>Em parceria com a UNIPAZDF – Universidade Internacional da Paz lançamos essa especialização, buscando oferecer oportunidade nesse momento pós pandemia de Cuidar de quem Cuida, de forma ampla e sistêmica.</p><p>O <b><i>Cuidado Integral – Terapia da Inteireza</i></b> é uma proposta integrativa de formação na ciência e arte terapêutica, fundamentada na abordagem transdisciplinar holística, que tem sido desenvolvida e irradiada há três décadas, no Brasil e no exterior, pela UNIPAZ. </p><p>Você vai aprender numa <b>escola do Encontro transdisciplinar</b> que ensina um jeito de <b>cuidar do humano</b>, a partir de uma visão aberta, da escuta inclusiva, da hermenêutica plural e do acompanhamento do processo que se desvela no transtemporal agora.</p><p>Propomos <b>Ressignificar o conceito de terapia</b> e da atitude terapêutica como a arte de cuidar da inteireza humana, considerando o solo fértil de uma <b>Ecologia do Encontro</b> como a sua matriz essencial, pautado sob a visão aberta do ser humano como um composto somático, psíquico e noético.</p>',
        investimento: [
            {
                valor: 450,
                centavos: 0,
                label: '18 parcelas de'
            },
            {
                valor: 6480,
                centavos: 0,
                label: 'À vista (20% de desconto)'
            }
        ],
        matrizes: [
            {
                titulo:'Módulo I: Introdução',
                itens:[
                    'Disciplina I – Terapia da Inteireza: Ciência e Arte do Cuidado Integral',
                ],
            },
            
            {
                titulo:'Módulo II: Cartografia da Inteireza',
                itens:[
                    'Disciplina I – Antigos e Novos Terapeutas: Abordagem Transdisciplinar em Terapia',
                    'Disciplina II – Caminhos do Encontro e do Cuidado',
                    'Disciplina III – O Poder do Encontro: origem do Cuidado',
                    'Disciplina IV – Mitos, Ritos e Sonhos: Ressonâncias Arquetípicas',
                    'Disciplina V – Ecologia da Presença: Mensagens do Deserto',
                    'Disciplina VI – Rios do Ego, o Oceano do Ser',
                    'Disciplina VII – O Totem Humano: o Desafio da Inteireza',
                ],
            },
            
            {
                titulo:'Módulo III: Corpo, o texto sagrado',
                itens:[
                    'Disciplina I - Vivenciando a Paz na Mente, Corpo e Emoções',
                    'Disciplina II – O Corpo, texto Sagrado: Paisagens d’Alma',
                    'Disciplina III – O Corpo de Asas e Raízes: A maternidade d’Alma',
                    'Disciplina IV – O Corpo dos Desejos: da escassez à abundância',
                    'Disciplina V – O Corpo Impermanente: acolhendo vida-morte-vida no cotidiano',
                    'Disciplina VI – O Corpo da Confiança: Harmonia e Conflito',
                    'Disciplina VII – O Corpo que Ama: Trilhas da Entrega',
                ],
            },
            
            {
                titulo:'Módulo IV: Aplicações Práticas - Imersão',
                itens:[
                    'Disciplina I - Experienciando o Cuidado Integral na Prática',
                ],
            },
            
            {
                titulo:'Módulo V: Integração',
                itens:[
                    'Disciplina I – A Prática e a Ética do Cuidado',
                    'Disciplina II - O Facilitador do Cuidado Integral: Eu, Outro e a Natureza',
                ],
            },
            
            {
                titulo:'Módulo VI: Obra-Prima',
                itens:[
                    'Orientação - Obra-Prima',
                    'Elaboração/Apresentação da Obra Prima',
                ],
            },
        ],
        parceiros: [
            {
                url: 'https://unipaz.org.br/',
                img: 'unipaz.png',
            }
        ],
        diferenciais: [
            {
                titulo:'Visão além do convencional',
                descricao:'Incluindo todas as áreas da gestão universitária.'
            },
            {
                titulo:'Habilitação p/ prática do Cuidado Integral',
                descricao:'Aprendizado teórico-vivencial da ecologia individual, social e ambiental.'
            },
            {
                titulo:'Educação para a vida com sentido na inteireza do cuidado',
                descricao:'Preparo de pessoas que se tornam agentes de saúde integral, nas áreas clínica, social e ambiental.'
            },
        ],
        professores: [
            {
                nome: 'Roberto Crema',
                curriculo:'Psicólogo, Antropólogo e Mestre em Ciências Humanas e Sociais pela Universidade de Paris. Criador do enfoque da Síntese Transacional – uma Ecologia do Ser, na perspectiva de uma quinta força em terapia. Coordenador geral do I Congresso Holístico Internacional (1987), que impulsionou a criação da UNIPAZ. Introdutor, no Brasil, da Formação Holística de Base (1989) e do Colégio Internacional dos Terapeutas (1992). Membro honorário da Associação Luso Brasileira de Transpessoal – ALUBRAT, Fellowship da Findhorn Foundation (Escócia). Reitor da Universidade Internacional da Paz – UNIPAZ. Autor e coautor de 30 livros.',
                image: '/staff/roberto-crema.png',
            },
            {
                nome:'Lydia Rebouças',
                curriculo:'Educadora, Psicóloga e Mestra em Psicologia, com 33 anos de experiência na área clínica. Dirigiu o Projeto UniverCidade, primeira iniciativa a aplicar a abordagem holística em Brasília (1986). Cofundadora da UNIPAZ no Brasil e Vice-reitora da Rede UNIPAZ. Especializações em Psicologia Transpessoal com Prof. Dr. Pierre Weil e Core Energetics com Dr. John Pierrakos. Facilitadora de palestras, seminários e formações de facilitadores no Brasil e no exterior. Membro do Colégio Internacional dos Terapeutas, CIT-Brasil. Escritora, jardineira, artesã, velejadora e peregrina. Autora d’A Inventadeira.',
                image: '/staff/lydia-reboucas.png',
            },
            {
                nome:'Nelma da Silva Sá',
                curriculo:'Educadora, Coach de Transição, Consultora em Implantação de Projetos com Foco na Cultura da Paz. Especialista em dinâmica organizacional, desenvolvimento de lideranças e em transdisciplinaridade. Diretora Presidente da UnipazSP.',
                image: '/staff/nelma-da-silva.png',
            },
        ],
        coordenadores: [
              {
                nome:'Nelma da Silva Sá',
                curriculo:'Educadora, Coach de Transição, Consultora em Implantação de Projetos com Foco na Cultura da Paz. Especialista em dinâmica organizacional, desenvolvimento de lideranças e em transdisciplinaridade. Diretora Presidente da UnipazSP.',
                image: '/staff/nelma-da-silva.png',
            },
        ],
    },
    {
        slug: 'mba-em-gestao-universitaria',
        inscricao:'https://portal.multiversa.com/inscricao-pos',
        name: 'MBA em Gestão Universitária',
        img: '/cursos/mba-1.jpg',
        area: 'Educação',  
        categoria:'Pós-graduação',
        meta_tags:'educação, pós-graduação, gestão universitária, foz do iguaçu, multiversa, neoperspectiva',
        description_seo: "O MBA em Gestão Universitária da Faculdade Multiversa em parceria com a Neoperspectiva Consultoria Educacional é o mais completo programa de formação de gestores de instituições de ensino superior do Brasil.",
        competencias: [],
        data_inicio: "11",
        mes_inicio: "março",
        ano_inicio: "2023",
        modalidade: 'Online',
        video: 'OF9LRJmvMTQ',
        cards: [
            {
                icon:'fas fa-arrows-to-eye',
                title: 'Veja o todo',
                description: 'O curso oferece uma visão sistêmica sobre todas as principais áreas da gestão universitárias.'
            },
            {
                icon:'fas fa-book',
                title: 'Conhecimento pra valer',
                description: 'Emprega conteúdo pragmático baseado no dia-a-dia da gestão de uma Instituição de Ensino Superior.'
            },
            {
                icon:'fas fa-certificate',
                title: 'Experiência comprovada',
                description: 'O curso é apresentado por professores com larga experiência de sucesso na gestão universitária.'
            },
            {
                icon:'fas fa-square-check',
                title: 'Pronto pra usar',
                description: 'Os conteúdos que você estudar no curso possuem aplicabilidade prática imediata, pois são conectados com a realidade.'
            },
            {
                icon:'fas fa-ranking-star',
                title: 'O que há de mais moderno',
                description: 'Acesse as mais atualizadas ferramentas e modelos de gestão da era da Tecnologia Cognitiva Digital.'
            },
        ],
        turmas: [
            { inicio: "11 de março de 2023", horario: "aulas quinzenais - 9h às 12h"},
        ],
        months: [
            {
                dates1: ["2023-03-11", "2023-03-25"],
            },
            {
                dates1: ["2023-04-15", "2023-04-29"],
            },
            {
                dates1: ["2023-05-13", "2023-05-27"],
            },
            {
                dates1: ["2023-06-03", "2023-06-17"],
            },
            {
                dates1: ["2023-07-01", "2023-07-15", "2023-07-29"],
            },
            {
                dates1: ["2023-08-12", "2023-08-26"],
            },
            {
                dates1: ["2023-09-09", "2023-09-23"],
            },
            {
                dates1: ["2023-10-07", "2023-10-21"],
            },
            {
                dates1: ["2023-11-04","2023-11-18"],
            },
            {
                dates1: ["2023-12-02"],
            },
        ],
        carga_horaria: '<p class="my-0">10 módulos de 40h cada</p><p class="my-0">(6h síncronas + 34h assíncronas)</p><p class="my-0">+ 60 horas do projeto de curso e preceptoria síncrona</p>',
        duracao: "12 meses",
        descricao: '<p>O MBA em Gestão Universitária da Faculdade Multiversa em parceria com a Neoperspectiva Consultoria Educacional é o mais completo programa de formação de gestores de instituições de ensino superior do Brasil. Ele está estruturado à partir dos seguintes elementos:</p><ul style="list-style: none;"><li> <p><i class="fas fa-check mr-3"></i>Visão sistêmica de todas as principais áreas da gestão universitária.</p></li><li> <p><i class="fas fa-check mr-3"></i>Conteúdo pragmático baseado no dia-a-dia da gestão de uma IES.</p></li><li> <p><i class="fas fa-check mr-3"></i>Professores com larga experiência de sucesso na gestão universitária.</p></li><li> <p><i class="fas fa-check mr-3"></i>Aplicabilidade prática imediata dos temas estudados no curso.</p></li><li> <p><i class="fas fa-check mr-3"></i>Conexão com as mais atualizadas ferramentas e modelos de gestão da era da Tecnologia Cognitiva Digital.</p></li></ul><p>O curso é coordenado pelo Professor Ryon Braga, um dos mais experientes gestor universitário do Brasil, tendo coordenado a formação de mais de 1.200 gestores em aproximadamente 38 programas educacionais nos últimos 22 anos.</p>',
        investimento: [
            {
                valor: 450,
                centavos: 0,
                label: '18 parcelas de'
            },
            {
                valor: 6480,
                centavos: 0,
                label: 'À vista (20% de desconto)'
            }
        ],
        matrizes: [
            {
                titulo:'Mercado e Competitividade',
                itens:[
                    'Participação no mercado (market share e sales share)',
                    'Análise da Concorrência',
                    'Estratégia e Posicionamento',
                    'Portfólio e precificação',
                ],
            },
            
            {
                titulo:'Gestão Estratégica de Instituições de Ensino',
                itens:[
                    'O planejamento estratégico no contexto da era digital',
                    'Ferramentas e modelos de gestão do século XXI',
                    'Flexibilidade e dinamicidade no planejamento e na gestão (reinvenção permanente)',
                    'Gestão baseada em evidências',
                ],
            },
            
            {
                titulo:'Marketing e Vendas',
                itens:[
                    'As especificidades do marketing nas instituições de ensino',
                    'Estratégias de captação',
                    'Marketing digital aplicado a instituições de ensino',
                    'Ações comerciais e promocionais',
                ],
            },
            
            {
                titulo:'Gestão Acadêmica',
                itens:[
                    'Design da experiência acadêmica do aluno',
                    'Canais de relacionamento e interfaces educacionais',
                    'Gestão da permanência e da evasão',
                    'Gestão do relacionamento com egressos',
                ],
            },
            
            {
                titulo:'Gestão do Processo Regulatório',
                itens:[
                    'Gestão do processo regulatório',
                    'DCNs, PDI, PPI, PPC, Estatuto, Regimento e demais documentos acadêmicos',
                    'Aspectos jurídicos do processo regulatório e a LGPD',
                    'Instrumentos de avaliação e comissões de visita in loco',
                ],
            },
            
            {
                titulo:'Gestão do Modelo Educacional (do Projeto Pedagógico Institucional)',
                itens:[
                    'Modelos educacionais inovadores',
                    'Tipos de modelos possíveis e a questão do modelo híbrido',
                    'Elaboração de matrizes curriculares e integrações horizontais e verticais',
                    'Processos motivacionais e de engajamento',
                ],
            },
            
            {
                titulo:'Gestão Financeira de IES',
                itens:[
                    'Orçamento',
                    'Indicadores de Desempenho',
                    'Financiamentos, descontos e bolsas',
                    'Gestão de custos e despesas',
                ],
            },
            
            {
                titulo:'Gestão da Operação e dos Processos',
                itens:[
                    'Gestão do atendimento ao cliente',
                    'Processos motivacionais e comprometimento dos colaboradores',
                    'Gestão dos processos operacionais',
                    'Gestão da infraestrutura e tecnologia',
                ],
            },
            
            {
                titulo:'Gestão da Tecnologia e do EAD',
                itens:[
                    'Tecnologia aplicada à gestão e ao ensino',
                    'O EAD e seus diversos modelos',
                    'Viabilizando o EAD em pequenas e médias IES',
                    'Transformação Digital nas instituições de ensino',
                ],
            },
            
            {
                titulo:'Visão Sistêmica e Gestão de Pessoas',
                itens:[
                    'Conhecimento sistêmico do negócio educação',
                    'Gestão de pessoas e mudanças em instituições de ensino',
                    'Governança corporativa em instituições de ensino',
                    'Cultura e clima organizacional em instituições de ensino',
                ],
            },
            
            
        ],
        parceiros: [
            {
                url: 'https://maisaedu.com.br',
                img: 'maisa.png',
            },
            {
                url: 'https://workalove.com',
                img: 'workalove.png',
            },
            {
                url: 'https://swa.com.br',
                img: 'swa-jacad.png',
            },
            {
                url: 'https://www.idc19.com.br/',
                img: 'idc19.png',
            },
            {
                url: 'http://neoperspectiva.com.br',
                img: 'neo.png',
            },
            {
                url: 'https://persone.com.br/',
                img: 'persone.png',
            },
            {
                url: 'https://educa-insights.com.br/',
                img: 'educa.png',
            },
        ],
        diferenciais: [
            {
                titulo:'Programação Completa',
                descricao:'Incluindo todas as áreas da gestão universitária.'
            },
            {
                titulo:'Visão Sistêmica da Gestão Universitária',
                descricao:'Não basta contemplar todas as áreas da gestão, é preciso integrá-las. Neste ponto este MBA é ímpar, pois consegue relacionar todas as áreas da gestão universitária, dentro de uma mesma linha estratégica.'
            },
            {
                titulo:'Total Aplicabilidade Prática',
                descricao:'O MBA não se limita a ensinar conteúdos, mas atua no desenvolvimento das competências essenciais à gestão de instituições de ensino.'
            },
            {
                titulo:'Aprenda com Quem Faz',
                descricao:'O curso é todo ministrado por professores gestores, de diversas regiões do país, com ampla experiência e sucesso profissional em suas atividades.'
            },
            {
                titulo:'Inovação',
                descricao:'O MBA apresenta as mais modernas ferramentas de gestão da era digital e sugere um novo e inédito modelo de se administrar instituições de ensino.'
            },
            {
                titulo:'Flexibilidade',
                descricao:'O curso é formato modular, permitindo a entrada do aluno em diferentes momentos e possibilitando a reposição posterior dos módulos perdidos.'
            },
            {
                titulo:'Networking',
                descricao:'O conjunto de aulas e atividades síncronas irão permitir a interação com gestores de diferentes IES das mais diversas regiões do país.'
            },
            {
                titulo:'Metodologia',
                descricao:'O curso utiliza metodologia ativa de aprendizagem diferenciada, com base na aplicabilidade prática do conteúdo em desafios reais.'
            }
        ],
        professores: [
            {
                nome: 'Ryon Braga',
                curriculo:'Diretor e Mantenedor da Faculdade Multiversa e presidente da Neoperspectiva Consultoria Educacional. Foi Reitor e mantenedor do Centro Universitário UniAmérica por 9 anos. Sócio-diretor da Atmã Educação e Diretor Técnico da ABMES (Associação Brasileira de Mantenedoras de Ensino Superior). Foi fundador da Hoper Educação, empresa que presidiu por 20 anos e, também, da Multiversa Advisors (empresa de M&A especialidade no segmento educacional). Foi também Diretor Estatutário do Grupo Anima Educação SA e sócio criador do SAGAH – Soluções Educacionais Integradas (maior empresa de produção de conteúdos para EAD, pertencente ao grupo +A Educação). Autor de quatro livros no segmento educacional e consultor para 352 universidades em cinco países: Brasil, Chile, Peru, Paraguai e Colômbia.',
                image: '/staff/ryon3.jpg',
                livros: ['/livros/livro-1.jpg', '/livros/livro-2.jpg', '/livros/livro-0.jpg']
            },
            {
                nome:'Rui Fava',
                curriculo:'Consultor da Neoperspectiva Consultoria Educacional. Foi Reitor da Universidade de Cuiabá e também reitor da Universidade do Norte do Paraná (UNOPAR). Foi Vice-presidente Acadêmico da Kroton Educacional e VP Acadêmico da Anima Educação. Foi também Vice-presidente of Business Development da Higher ed Partners. Graduado em Administração, com MBA em Finanças e Doutorado em Ciência da Educação. Autor de cinco obras no segmento educacional.',
                image: '/staff/rui.jpeg',
                livros: ['/livros/livro-7.jpg', '/livros/livro-5.jpg', '/livros/livro-4.jpg', '/livros/livro-3.jpg']
            },
            {
                nome:'Fausto Camargo',
                curriculo:'Administrador e Coordenador do Curso de Administração da Faculdade Multiversa. Doutor em Sociedade, Cultura e Fronteiras pela UNIOESTE-PR e Mestre em Ciências Sociais pela UNISINOS-RS. Sócio fundador da Neoperspectiva Consultoria Educacional e Professor no Ensino Superior desde 2005. Possui experiência na implantação de Metodologias Ativas de Aprendizagem, Ensino Híbrido, Aprendizagem baseada em Projetos e em formação docente. Autor do livros: “A Sala de Aula Inovadora: estratégias pedagógicas para fomentar o aprendizado ativo” e “A Sala de Aula Digital: Estratégias Pedagógicas para Fomentar o Aprendizado Ativo on-Line e Híbrido”.',
                image: '/staff/fausto.jpg',
                livros: ['/livros/livro-10.jpg', '/livros/livro-6.jpg']
            },
            {
                nome:'Daniel Infante',
                curriculo:'Possui graduação em Marketing pela Universidade de São Paulo (2008) e mestrado em Administração com ênfase em Marketing pela Faculdade de Economia, Administração e Contabilidade - USP (2015). Atualmente é sócio-diretor no instituto de pesquisa Educa Insights. Tem experiência na área de Administração, com ênfase em MARKETING, atuando principalmente nos seguintes temas: pesquisa de marketing, consumidores, equity de marca e marketing.',
                image:'/staff/daniel-infante.jpg',
            },
            {
                nome:'Gilberto Zembrani',
                curriculo:'Pró-reitor Acadêmico do Centro Universitário UniAmérica Descomplica. Professor em cursos de pós-graduação na área de educação. Membro do Conselho Deliberativo do Instituto Superior de Aprendizagem Ativa, mantenedor da Faculdade Multiversa. Sócio fundador da Neoperspectiva Consultoria Educacional. Formado em Geografia pelas Faculdades Integradas de Naviraí com MBA em Metodologias Ativas e MBA em Educação Híbrida pelo Centro Universitário União das Américas. Atua na área de Gestão Acadêmica. Possui mais de 10 anos de experiência na educação superior, com vivência na implementação de modelos educacionais inovadores, gestão e otimização de custos acadêmicos, legislação educacional e processos regulatórios.',
                image:'/staff/gilberto.jpg',
            },
            {
                nome:'Daniel Sperb',
                curriculo: 'É Vice-Presidente Executivo de Inovação - CIO na Imed e fundador da EdTech Be Formless, cujos softwares são utilizados pelas mais importantes universidades do país. Com mais de 18 anos de experiência em gestão universitária, criou softwares para alavancagem de resultados em Avaliações In Loco, ENADE, Projetos Integradores, além de metodologias autorais para posicionamento estratégico baseado em diferenciação utilizadas por diversas instituições de ensino superior do Brasil. É graduado em Design Industrial, Especialista em Educação, Mestre em Engenharia de Produção pela UFSM e Doutor no tema criatividade pelo PPGEP UFRGS.',
                image:'/staff/sperb.jpg',
            },
            // {
            //     nome:'Michel Zardo',
            //     curriculo:'Assessor de Regulação na Associação Internacional União das Américas Descomplica. Possui graduação em Ciência da Computação pela Universidade Estadual do Oeste do Paraná(2000). Tem experiência na área de Ciência da Computação, com ênfase em Análise e Desenvolvimento de Sistemas.',
            //     image:'/staff/michel.jpg',
            // },
            {
                nome:'Luiz Filipe Trivelato',
                curriculo:'Trivelato é COO da +A Educação. Envolvido há 15 anos com Educação Superior no Brasil e América Latina, atuou em funções relacionadas ao desenvolvimento de novos negócios, planejamento estratégico, fusões e aquisições na Kroton Educacional e na Rede Laureate de Universidades. Nos últimos anos, dedicou-se a projetos inovadores no setor: a +Campus, maior ecossistema de Instituições para operação de EAD; a SAGAH, provedora de soluções para ensino presencial e EAD; e a Educa Insights, empresa que mudou o conceito de pesquisas de mercado para o setor de educação.',
                image:'/staff/trivelato.png',
            },
            {
                nome:'Blasius Debald',
                curriculo:'Sócio fundador da Neoperspectiva Consultoria Educacional. Doutor em Educação e Mestre em Desenvolvimento Regional, Área Sociocultural e Especializações em Gestão de Aprendizagem, Metodologias Ativas e Educação Híbrida. Foi Diretor Geral de IES, coordenador de curso de graduação e pós-graduação. Atualmente é docente e Pró-reitor de Ensino do Centro Universitário UniAmérica Descomplica, integrante da Equipe Editorial da Revista Pleiade da mesma Instituição. Tem experiência na área de Educação Superior, especialmente na utilização de metodologias inovadoras e novo perfil docente. Dedica-se a pesquisa que se articulam com a promoção do protagonismo estudantil, aprendizagem baseada por competência, introdução de metodologias ativas de aprendizagem, mediação docente e formatos avaliativos. Assessora a implementação do currículo por competência e o desenvolvimento de planejamento docente inovador para a prática educativa.',
                image: '/staff/blasius.jpeg',
                livros: ['/livros/livro-11.jpg']
            },
            {
                nome:'Norma Viapiana',
                curriculo:'Sócia fundadora Neoperspectiva Consultoria Educacional. Mestre em Educação, Especialista em Fundamentos Psicológicos da Educação e graduada em Pedagogia. Atuou como Pró-Reitora Acadêmica da Unioeste-PR. Foi consultora da Hoper, atuando na área acadêmica. Tem mais de 20 anos de experiência em consultoria. Foi vice-Reitora do Centro Universitário Uniamérica.',
                image:'/staff/norma.png',
            },
            {
                nome:'Tório Barbosa',
                curriculo:'Tório Barbosa, reconhecido como referência em captação de alunos no Brasil, foi fundador e CEO de uma das maiores e mais conceituadas agências de publicidade especializada em instituições de ensino do país. Atualmente é co-fundador da Mkt4edu, empresa especializada em captação de alunos com inovação e tecnologia, com mais de 50 clientes, em 3 países. A empresa conta com colaboradores em mais de 5 países, presente em mais de 14 cidades no mundo e usa mais de 34 softwares para ajudar nos processos de captação. Mesmo iniciando suas atividades em 2017, a Mkt4edu vem ganhando sucessivos prêmios e reconhecimentos pela inovação e bom uso de tecnologia para captação de alunos na educação.',
                image:'/staff/torio.jpg',
            },
            {
                nome:'Raiza Brustolin',
                curriculo:'Coordenadora de Tecnologias Educacionais e Docente dos cursos de graduação e pós-graduação em Educação no Centro Universitário UniAmérica Descomplica. Sócia fundadora da Neoperspectiva Consultoria Educacional. Especialista em Metodologias Ativas (UNIAMÉRICA), Mestre em Sociedade Cultura e Fronteiras (UNIOESTE) e Pesquisadora de TDICs no Ensino Superior (UNIOESTE).',
                image:'/staff/raiza.jpeg',
            },
            {
                nome:'Daniela Paiva',
                curriculo:'Especialista em Educação com ênfase em metodologias ativas de aprendizagem e gestão educacional no Ensino Superior. Já atuou como Coordenadora de Pós-graduação Lato Sensu. Sócia fundadora da Neoperspectiva Consultoria Educacional. Possui experiência com desenvolvimento de matriz curricular baseado em projetos e competências, bem como, a estrutura de programas formativos para desenvolvimento e atuação no ensino superior e educação básica, através de metodologias ativas de aprendizagem. Atualmente lidera um time de Operações Acadêmicas de Pós-graduação e atua como docente de Graduação e Pós- graduação, sobretudo, na área de formação de professores e gestão acadêmica.',
                image:'/staff/daniela.jpeg',
            },
            {
                nome:'Allysson Costa',
                curriculo:'Sócio fundador da Neoperspectiva Consultoria Educacional. É Pró-reitor de Pesquisa e Extensão, docente na Pós-Graduação em Gestão em Gestão da Aprendizagem e docente no curso de Educação Física, no Centro Universitário União das Américas Descomplica em Foz do Iguaçu (PR). Possui Graduação em Educação Física Licenciatura (2011). Graduação em Educação Física Bacharelado (2015). MBA em Gestão Empresarial (2015). MBA em Educação Hibrida (2019). Mestrado em Ciências pelo Programa de Pós-Graduação em Biociências da Universidade Federal da Integração Latino-Americana (UNILA) (2019). MBA em Inovação da Aprendizagem em Docência da Educação Superior (2020).',
                image:'/staff/allysson.jpeg',
            },
            {
                nome:'Lúcia Makhlouf',
                curriculo:'Sócia fundadora da Neoperspectiva Consultoria Educacional, graduada em Direito pela Universidade de São Paulo, Pós Graduada em Regulação das Telecomunicações pela UnB (Universidade de Brasília) e MBA Executivo em Administração e Marketing pelo INSPER. Gestora Educacional na área de Sucesso do Cliente há 9 anos e Pró-Relacionamento do Centro Universitário UniAmérica Descomplica.',
                image:'/staff/lucia.jpg',
            },
            {
                nome:'Rafael Villas Bôas',
                curriculo:' atua há 20 anos em gestão de marketing educacional já tendo participado como executivo, de algumas das mais importantes instituições de ensino do Brasil e em projetos de consultoria, educação e intercâmbio em mais de uma centena de faculdades de todo país e no mundo. É autor de diversos livros, artigos e estudos sobre marketing e mercado publicados nos mais importantes veículos do segmento como The Campus Experience – Marketing pra Instituições de Ensino (2009). Formado em Comunicação Social pela Universidade Positivo, é MBA em Gestão Estratégica de Negócios pela Fundação Getúlio Vargas e Especialista em Gestão Educacional pela Universidade Anhembi Morumbi. Atualmente é head de marketing de educação continuada na Afya Educação e Tecnologia. É, ainda, publisher do portal marketingeducacional360.com.br.',
                image:'/staff/rafa.jpg',
            }
            
            
        ],
        banner: {
            background: '/banners/bg-mba.jpg',
            subtitulo: 'Também pode ser adquirido em',
            titulo: 'Módulos Individuais <br><small class="font-400">Conheça os cursos:</small>',
            descricao: `
            <p>O MBA em Gestão Universitária é o mais completo programa de formação de gestores de instituições de ensino superior do Brasil.</p>
            <p>Agora, além do programa completo, você pode escolher quais módulos deseja cursar, de modo individual e autônomo! Você se inscreve e realiza apenas o módulo que quiser.</p>
            <p>Mas o melhor é que a qualquer momento pode optar por continuar cursando todos os 10 módulos do curso e obter o certificado de especialista no MBA de Gestão Universitária.</p>
            `,
            ctas: [
                {
                    texto: 'Mercado e Competitividade',
                    url: '/cursos/mercado-educacional-e-competitividade'
                },
                // {
                //     texto: 'Gestão Acadêmica',
                //     url: '/cursos/mercado-educacional-e-competitividade'
                // }
            ]
        }
    },
    {
        slug: "mba-em-novos-negocios-do-turismo-e-hotelaria",
        inscricao:'https://portal.multiversa.com/inscricao-pos',
        name: "MBA em Novos Negócios do Turismo e Hotelaria",
        descricao: "<p>Há um grande movimento liderado pelo Ministério do Turismo e com forte investimento da iniciativa privada, que ganha consistência para aumentar o potencial turístico do país, beneficiando toda a cadeia produtiva do setor, onde o caminho traçado é o da inovação.</p><p>Os investimentos são em diagnósticos e na implantação de Hubs de Inovação e Ecossistemas Empreendedores (incubadoras, aceleradoras e startups) para promoção de mudanças no turismo, com foco na melhoria da experiência do viajante, agregando valor aos serviços ofertados em toda a cadeia turística.</p><p>O Brasil lidera o crescimento de Venture Capital na América Latina, com mais de 12 mil startups ativas e investimentos que superam os R$ 9 bilhões. Neste cenário, a faculdade Multiversa tem expertise, conhecimento e convicção de que pode estimular ainda mais estas iniciativas e ajudar este ecossistema a crescer em todo o país.</p><p>Com este propósito, criamos o MBA em Novos Negócios do Turismo e Hotelaria, um programa revolucionário para preparar empreendedores, empresas, organizações e profissionais a criar novos negócios, produtos e serviços, gerar novas soluções, superar desafios de crescimento e consolidar os investimentos no turismo.</p><p>No MBA as trilhas de conhecimento levarão os participantes a terem acesso às tendências, inovações e oportunidades do mercado turístico e de hospitalidade e a criar e validar o seu próprio negócio, por meio da metodologia de lean startup, desenvolvendo e testando um produto mínimo viável (MVP).</p><p>Este processo será estimulado e amparado por um ecossistema empreendedor, formado por profissionais especializados e um grupo seleto de mentores, com cases de negócios consolidados no mercado em todo o país.</p><p>Ao testar o negócio, produto ou serviço, os participantes do MBA terão a oportunidade de modelar e desenvolver o seu Plano de Negócios. O programa é extremamente inovador ao proporcionar aos participantes, ainda, uma imersão no ecossistema empreendedor da região, nos principais equipamentos e atrativos turísticos de Foz do Iguaçu (Segundo destino turístico do Brasil) e a apresentação de um PITCH de 7 minutos a um grupo seleto de investidores.</p><p>A faculdade entende que inovação é energia positiva que gera transformação e que o turismo é a grande mola propulsora para a recuperação da economia do país.</p>",
        img: "/cursos/novos-negocios.jpg",
        categoria: "Pós-graduação",
        area: 'Turismo e Hotelaria',
        meta_tags:'educação, pós-graduação, turismo, hotelaria, foz do iguaçu, multiversa, neoperspectiva',
        description_seo: "O curso é um programa revolucionário para preparar empreendedores, empresas, organizações e profissionais a criar novos negócios, produtos e serviços, gerar novas soluções, superar desafios de crescimento e consolidar os investimentos no turismo.",
        data_inicio: "13",
        mes_inicio: "março",
        ano_inicio: "2023",
        carga_horaria:'360 horas/aulas',
        duracao: '12 meses',
        competencias:["Desenvolver mindset empreendedor","Desenvolver Pesquisa de Mercado no segmento de turismo e hospedagem","Identificar tendências do mercado turístico e hoteleiro","Identificar oportunidades de inovação no mercado turístico e hoteleiro","Criar e validar um Produto Mínimo Viável (MVP)","Mapear o ecossistema do turismo e hotelaria.","Desenvolver Planejamento estratégico inovador","Elaborar o Plano de Negócios","Apresentar Pitch para investidores"],
        investimento: [{ "label": "18 Parcelas de", "valor": 350 }],
        turmas: [
            { inicio: '13 de março de 2023', horario: 'quinzenal às 19h'},
        ],
        months: [
            {
                dates1: ["2023-03-13", "2023-03-27"],
            },
            {
                dates1: ["2023-04-10", "2023-04-24"],
            },
            {
                dates1: ["2023-05-08", "2023-05-22"],
            },
            {
                dates1: ["2023-06-05", "2023-06-19"],
            },
            {
                dates1: ["2023-07-03", "2023-07-17", "2023-07-31"],
            },
            {
                dates1: ["2023-08-14", "2023-08-28"],
            },
            {
                dates1: ["2023-09-11", "2023-09-25"],
            },
            {
                dates1: ["2023-10-09", "2023-10-23"],
            },
            {
                dates1: ["2023-11-06", "2023-11-20"],
            },
            {
                dates1: ["2023-12-04", "2023-12-18"],
            },
            {
                dates1: ["2024-01-15", "2024-01-29"],
            },
            {
                dates1: ["2024-02-19"],
            },
            {
                dates1: ["2024-03-04", "2024-03-18"],
            }
        ],
        matrizes: [
            {
                titulo: 'Módulo l: Empreendedorismo e o Ecossistema',
                itens:[
                    'Empreendedorismo e Propósito de valor',
                    'Mercado do Turismo e Hotelaria: Oportunidades e Desafios',
                    'Ecossistema do turismo e hotelaria: DTI e Serviços de Experiência',
                    'Parcerias público-privadas, cessão e concessão',
                    'Empreendedorismo',
                    'Mentalidade empreendedora',
                    'Análise de oportunidades',
                    'Comportamento do consumidor e pesquisa de mercado',
                    '01 Desafio empreendedor',
                    '01 Estudo de caso real e aplicado',
                    '02 mentorias coletivas',
                    '03 masterclasses',
                ]
            },
            {
                titulo: 'Módulo ll:  Tendências de Mercado e Produtos Turísticos',
                itens:[
                    'Tendências tecnológicas do turismo e Hotelaria',
                    'Design de Produtos Turísticos e Hoteleiros',
                    'Design Thinking: Compreensão do problema',
                    'Novas tendências de consumo e relação com o marketing',
                    'Consumidor 4.0 os fornecedores e o novo comportamento de consumo',
                    'Consumidor Omnichannel',
                    'Uso da criatividade para a solução de problemas',
                    'Criação de valor',
                    'A produção e o consumidor',
                    '01 Desafio empreendedor',
                    '01 Estudo de caso real e aplicado',
                    '02 mentorias coletivas',
                    '03 masterclasses',
                ]
            },
            {
                titulo: 'Módulo lll: Inovação em Modelos de Negócios',
                itens:[
                    'MVP e Validação',
                    'Inovação em Modelos de Negócios',
                    'Pensamento Enxuto',
                    'Metodologia Startup enxuta / Lean Canvas',
                    'Business Model Canvas',
                    'SCRUM',
                    'Performance de diferentes tipos de modelos de negócios',
                    'Modelos de negócios em cenários de mudança',
                    'Valor das ideias de negócios ',
                    'Gestão e desenvolvimento de produtos e marcas',
                    '01 Desafio empreendedor',
                    '01 Estudo de caso real e aplicado',
                    '02 mentorias coletivas',
                    '03 masterclasses',
                ]
            },
            {
                titulo: 'Módulo lV: Estratégia e Inovação',
                itens:[
                    'Inovação no Turismo e Hotelaria',
                    'Estratégias de Inovação',
                    'Casos de inovação e empreendedorismo nas empresas',
                    'Missão, Visão e Valores',
                    'Planejamento e Inovação',
                    'Planejamento estratégico',
                    'Análise SWOT',
                    'Mapeamento do PE',
                    '01 Desafio empreendedor',
                    '01 Estudo de caso real e aplicado',
                    '02 mentorias coletivas',
                    '03 masterclasses',
                ]
            },
            {
                titulo: 'Módulo V: Plano de Negócios e Pitch',
                itens: [
                    'Planos de Negócios',
                    'Pitch',
                    'Análise de oferta e demanda',
                    'Plano de Marketing',
                    'Plano financeiro',
                    'Plano operacional',
                    '01 Desafio empreendedor',
                    '01 Estudo de caso real e aplicado',
                    '02 mentorias coletivas',
                    '03 masterclasses',
                ]
            },
            {
                titulo: 'Imersão no Turismo de Foz (Opcional)',
                itens: [
                    '01/04/2024: Cataratas + Belmond + almoço no Porto Canoas + Parque das Aves + Movie Cars',
                    '02/04/2024: Mabu Blue Park + Bourbon Resort + Centro de Inovação + tarde livre + Itaipu Iluminada',
                    '03/04/2024: CTI & Itaipu Especial + almoço Rafain Churrascaria + Complexo Dreamland',
                ]
            }
        ],
        parceiros: [
            {
                url: '',
                img: 'e21.png',
            },
            {
                url: 'https://www.hackatour.com/',
                img: 'logo-hackatur.svg',
            },
            {
                url: 'https://idestur.com/',
                img: 'logo-idestur.svg',
            },
            {
                url: 'https://festivaldascataratas.com/',
                img: 'logo-festival.svg',
            },
            {
                url: 'https://www.desbravador.com.br/',
                img: 'logo-desbravador.svg',
            },
            {
                url: 'https://www.grupocataratas.com/',
                img: 'logo-cataratas.svg',
            },
            {
                url: 'https://poloiguassu.org/',
                img: 'logo-polo-iguassu.svg',
            },
            {
                url: 'https://www.idc19.com.br/',
                img: 'idc19.png',
            },
        ],
        professores:[
            
            {
                "curriculo": "Economista pela UNESP, especialista em Marketing Turístico pelo Senac, tem MBA em Marketing Estratégico e Mestre em Ciências da Comunicação e Turismo pela USP. Realiza diversas palestras, webinars, consultorias e cursos na área de Marketing Digital, Mídias Sociais, Tendências, Inovação e Transformação Digital no Turismo",
                "image": "/staff/marta-poggi.jpg",
                "nome": "Marta Poggi"
            },
            {
                "curriculo": "Administrador, Diretor Executivo do Grupo Cataratas em Foz do Iguaçu, possui mais de 25 anos de experiência em gestão de hotelaria e atrativos turísticos, principalmente em unidade de conservação. Participou da implantação das operações da Cataratas do Iguaçu S.A no Parque Nacional do Iguaçu e no Marco das Três Fronteiras.",
                "image": "/staff/adelio-demeterko.jpg",
                "nome": "Adelio Demeterko"
            },
            {
                "curriculo": "Idealizador e organizador do Festival das Cataratas e do Hackatour, presidente do IDESTUR e atual Secretário de Turismo, Projetos Estratégicos e Inovação de Foz do Iguaçu",
                "image": "/staff/paulo-angeli.jpg",
                "nome": "Paulo Angeli"
            },
            
        ],
        diferenciais: [
            {
                "descricao": " A cada trilha o aluno aplica seu projeto à sua realidade profissional",
                "titulo": "Máxima aplicabilidade",
                "icon": "lightbulb"
            },
            {
                "descricao": "Momentos imersivos em Foz do Iguaçu para que você possa vivenciar no nível máximo a experiência",
                "titulo": "Encontro Imersivo (opcional)",
                "icon": "lightbulb"
            },
            {
                "descricao": " Master Class ao vivo com pessoas que são autoridades em inovação em turismo",
                "titulo": "Master Class com especialistas",
                "icon": "lightbulb"
            },
            {
                "descricao": " Acompanhamento e feedback personalizado com docentes experientes, garantindo o melhor aproveitamento por parte do aluno",
                "titulo": "Preceptoria",
                "icon": "lightbulb"
            },
            {
                "descricao": " Assessoria de tutor para organização e suporte técnico nos processos do curso",
                "titulo": "Assessoramento individual",
                "icon": "lightbulb"
            },
            {
                "descricao": "Certificados de competências ao longo do curso, enriquecendo seu currículo antes mesmo de concluir todo o MBA",
                "titulo": "Nano degree (Certificados Parciais)",
                "icon": "lightbulb"
            },
            {
                "descricao": " Todos os projetos aplicados durante o curso consideram as necessidades do contexto profissional do aluno",
                "titulo": "Aprendizagem personalizada",
                "icon": "lightbulb"
            },
            {
                "descricao": "Negócios criados pelos participantes do MBA receberão mentoria e serão incubados no Hub E21, espaço de empreendedorismo e inovação da Faculdade Multiversa.",
                "titulo": "Parcerias com Incubadoras e Aceleradoras",
                "icon": "lightbulb"
            },
            {
                "descricao": "Oportunidade de participar de workshops e visitas técnicas com foco nos modelos de negócios, nos âmbitos estratégicos e táticos, de estruturas como a Itaipu Binacional, Cataratas S/A e outras",
                "titulo": "Visitas técnicas",
                "icon": "lightbulb"
            },
            {
                "descricao": "Os alunos terão a oportunidade de participar do Festival de Turismo das Cataratas, segundo maior evento do turismo brasileiro",
                "titulo": "Participação em Eventos",
                "icon": "lightbulb"
            },
            {
                "descricao": "Os participantes terão a oportunidade de apresentar um PITCH de 7 minutos a um grupo seleto de investidores",
                "titulo": "Captação de Investimentos",
                "icon": "lightbulb"
            }
        ]
    },
    {
        slug: 'mercado-educacional-e-competitividade',
        inscricao:'https://portal.multiversa.com/inscricao-pos',
        name: 'Mercado Educacional e Competitividade',
        img: '/cursos/mercado-educacional.jpg',
        categoria:"Curso",
        area: 'Educação',  
        data_inicio: "22",
        mes_inicio: "outubro",
        ano_inicio: "2022",
        video:'',
        modalidade: 'Digital',
        turmas: [
            {
                inicio: '22 de outubro de 2022', horario: "aulas quinzenais - 9h às 12h"
            },
        ],
        months: [
            {
                dates1: ["2022-10-22"],
            },
            {
                dates1: ["2022-11-12"],
            },
        ],
        carga_horaria: '<p class="my-0">2 encontros síncronos</p><p class="my-0">6h síncronas + 34h assíncronas</p><p class="my-0">Total 40h</p>', 
        duracao: '1 mês',
        descricao: `
        <p class="c-secondary--text font-600">Objetivos do curso:</p>
        <p>O curso Mercado Educacional e Competitividade das IES visa atualizar aos profissionais da IES sobre as tendências de mercado, cenário competitivo, identificação de ameaças e oportunidades, bem como um aprendizado sobre as melhores técnicas e ferramentas para análise de portfólio, dimensionamento do mercado e precificação das mensalidades. </p>
        <p>Para isso, o curso, contará com materiais assíncronos e momentos de interação com profissionais que são referências no mercado educacional. O curso adotará ainda, uma metodologia prática ao qual o profissional terá a oportunidade de realizar um projeto na área, com acompanhamento e feedback. </p>
        <p>O curso conta com uma entrega do projeto final, que será vinculado a temática do curso com feedback do docente.</p>
        <br>
        
        <p class="c-secondary--text font-600">Mentoria Agendada</p>
        <p>Agende uma mentoria com um dos principais nomes de suas áreas de atuação. Tire dúvidas e consiga orientação prática com quem convive com as problemáticas do cotidiano da gestão universitária. A mentoria é opcional e o agendamento é realizado através do portal do aluno.</p>
        `,
        investimento: [
            {
                valor: 360,
                centavos: 0,
                label: '02 parcelas de'
            },
            {
                valor: 720,
                centavos: 0,
                label: 'À vista'
            }
        ],
        matrizes: [
            {
                titulo: 'Unidades Temáticas',
                itens:[
                    'Tendências e Perspectivas do Mercado Educacional',
                    'Gestão Baseada em Dados',
                    'Diagnóstico Mercadológico Estratégico',
                    'Qual o Tamanho e Oportunidades de Mercado para sua IES?',
                    'Análise Competitiva, Precificação de Mensalidades e Portfólio de Cursos',
                ],
                observacao: '<b>Conteúdos Online contém</b>: Vídeos Assíncronos e Textos de Apoio'
            },
            
        ],
        parceiros: [],
        diferenciais: [],
        coordenadores: [
            {
                nome: 'Ryon Braga',
                curriculo:'Diretor e Mantenedor da Faculdade Multiversa e presidente da Neoperspectiva Consultoria Educacional. Foi Reitor e mantenedor do Centro Universitário UniAmérica por 9 anos. Sócio-diretor da Atmã Educação e Diretor Técnico da ABMES (Associação Brasileira de Mantenedoras de Ensino Superior). Foi fundador da Hoper Educação, empresa que presidiu por 20 anos e, também, da Multiversa Advisors (empresa de M&A especialidade no segmento educacional). Foi também Diretor Estatutário do Grupo Anima Educação SA e sócio criador do SAGAH – Soluções Educacionais Integradas (maior empresa de produção de conteúdos para EAD, pertencente ao grupo +A Educação). Autor de quatro livros no segmento educacional e consultor para 352 universidades em cinco países: Brasil, Chile, Peru, Paraguai e Colômbia.',
                image: '/staff/ryon3.jpg',
                livros: ['/livros/livro-1.jpg', '/livros/livro-2.jpg', '/livros/livro-0.jpg']
            },
        ],
        banner: {
            background: '/banners/bg-mba.jpg',
            subtitulo: 'Esse curso é parte integrante do',
            titulo: 'MBA em Gestão Universitária',
            descricao: `
            <p>O MBA em Gestão Universitária é o mais completo programa de formação de gestores de instituições de ensino superior do Brasil.</p>
            <p>Agora, além do programa completo, você pode escolher quais módulos deseja cursar, de modo individual e autônomo! Você se inscreve e realiza apenas o módulo que quiser.</p>
            <p>Mas o melhor é que a qualquer momento pode optar por continuar cursando todos os 10 módulos do curso e obter o certificado de especialista no MBA de Gestão Universitária.</p>
            `,
            ctas: [
                {
                    texto: 'Conheça o MBA',
                    url: '/pos-graduacao/mba-em-gestao-universitaria'
                }
            ]
        }
    },
    {
        slug: 'formacao-de-consultores',
        inscricao:'https://portal.multiversa.com/inscricao-pos',
        name: 'Formação de Consultores Educacionais',
        img: '/cursos/formacao-de-consultores.jpg',
        categoria:"Curso",
        area: 'Educação',  
        data_inicio: "14",
        mes_inicio: "março",
        ano_inicio: "2023",
        video:'_MMeQdTqOdQ',
        modalidade: 'Digital',
        turmas: [
            {
                inicio: '14 de março de 2023', horario: '19h30 às 21h30'},
            ],
            months: [
                // {
                //     dates1: ["2022-09-14"],
                // },
                // {
                //     dates1: ["2022-10-05"],
                // },
                // {
                //     dates1: ["2022-11-23"],
                // },
            ],
            carga_horaria: '<p class="my-0">3 encontros síncronos</p><p class="my-0">12h síncronas</p><p class="my-0">78h assíncronas</p>', 
            duracao: '3 meses',
            descricao: '<p>O Programa de Formação de Consultores Educacionais da Neoperspectiva Consultoria é o mais completo programa de formação de consultores para instituições de ensino superior do Brasil. Ele está estruturado à partir dos seguintes elementos:</p><ul><li><p>Visão sistêmica de todas as principais áreas da gestão universitária.</p></li><li><p>Conteúdo pragmático baseado no dia-a-dia da gestão de uma IES.</p></li><li><p>Professores com larga experiência de sucesso na gestão universitária.</p></li><li><p>Aplicabilidade prática imediata dos temas estudados no curso.</p></li><li><p>Conexão com as mais atualizadas ferramentas e modelos de gestão da era da Tecnologia Cognitiva Digital.</p></li></ul><p>O curso é coordenado pelo Professor Ryon Braga, um dos mais experientes gestor universitário do Brasil, tendo coordenado a formação de mais de 1.200 gestores em aproximadamente 38 programas educacionais nos últimos 22 anos.</p><p class="font-600 c-secondary--text">VENHA FAZER PARTE DO MELHOR TIME DE CONSULTORES DE GESTÃO UNIVERSITÁRIA DO BRASIL</p><p>Alguns participantes do programa serão selecionados para fazer parte do quadro de Consultores da Neoperspectiva. Os demais, se quiserem, poderão trabalhar utilizando a metodologia de consultoria de Neoperspectiva e seus instrumentos de gestão, à partir de um contrato de parceria.</p>',
            investimento: [
                {
                    valor: 650,
                    centavos: 0,
                    label: '04 parcelas de'
                }
            ],
            matrizes: [
                
                {
                    titulo:'Mercado para Consultoria de Gestão Educacional',
                    itens:[
                        'Segmentação do mercado e tipos de clientes',
                        'Segmentação dos modelos de consultorias (dos processos às estratégias)',
                        'Regras e procedimentos das consultorias',
                        'Áreas de atuação das consultorias'
                    ]
                },
                {
                    titulo:'O Negócio Consultoria',
                    itens:[
                        'Prospecção de clientes',
                        'O ciclo de vendas',
                        'Formação dos times de trabalho no cliente',
                        'Precificação'
                    ]
                },
                {
                    titulo:'Competências Necessárias ao Consultor de Gestão Educacional',
                    itens:[
                        'Comunicação com o cliente',
                        'Visão sistêmica da gestão de instituições de ensino',
                        'Habilidades socioemocionais de relacionamento',
                        'Capacidade de criação de networking'
                    ]
                },
                {
                    titulo:'Gestão do Projeto da Consultoria',
                    itens:[
                        'Definição do escopo da consultoria',
                        'Elaboração do cronograma e atribuição das responsabilidades',
                        'Análise dos requisitos',
                        'Apresentação dos resultados'
                    ]
                },
                {
                    titulo:'Diagnóstico Institucional',
                    itens:[
                        'Componentes do Diagnóstico Institucional.',
                        'Análise da Concorrência e participação no mercado (market share e sales share).',
                        'Estratégia, posicionamento, portfólio e precificação.',
                        'Diagnóstico acadêmico e processual.'
                    ]
                },
                {
                    titulo:'Gestão Estratégica de Instituições de Ensino',
                    itens:[
                        'Ferramentas e modelos de gestão do século XXI.',
                        'Flexibilidade e dinamicidade no planejamento e na gestão (reinvenção permanente).',
                        'Gestão baseada em evidências.',
                        'Gestão dos processos operacionais, da infraestrutura e da tecnologia.'
                    ]
                },
                {
                    titulo:'Marketing e Vendas',
                    itens:[
                        'As especificidades do marketing nas instituições de ensino',
                        'Estratégias de captação e ações promocionais e comerciais.',
                        'Marketing digital aplicado a instituições de ensino',
                        'Gestão da permanência e da evasão'
                    ]
                },
                {
                    titulo:'Gestão Acadêmica',
                    itens:[
                        'Design da experiência acadêmica do aluno',
                        'Gestão do relacionamento com egressos',
                        'Processos motivacionais e de engajamento',
                        'Tipos de modelos possíveis e a questão do modelo híbrido'
                    ]
                },
                {
                    titulo:'Gestão do Processo Regulatório',
                    itens:[
                        'Gestão do processo regulatório',
                        'DCNs, PDI, PPI, PPC, Estatuto, Regimento e demais documentos acadêmicos',
                        'Aspectos jurídicos do processo regulatório e a LGPD',
                        'Instrumentos de avaliação e comissões de visita in loco'
                    ]
                },
                {
                    titulo:'Gestão Financeira e da Tecnologia em IES',
                    itens:[
                        'Gestão de custos, despesas e orçamento',
                        'Indicadores de Desempenho',
                        'Financiamentos, descontos e bolsas',
                        'Transformação Digital nas instituições de ensino'
                    ]
                },
                {
                    titulo:'EAD e Gestão de Pessoas',
                    itens:[
                        'O EAD e seus diversos modelos',
                        'Viabilizando o EAD em pequenas e médias IES',
                        'Gestão de pessoas e mudanças em instituições de ensino',
                        'Cultura e clima organizacional em instituições de ensino'
                    ]
                },
                
                
                
            ],
            
            parceiros: [
                {
                    url: "https://neoperspectiva.com.br",
                    img: "neo.png",
                },
                {
                    url: "https://maisaedu.com.br",
                    img: "maisa.png",
                },
                {
                    url: "https://www.mkt4edu.com",
                    img: "mkt4edu.png",
                },
                {
                    url: "https://swa.com.br",
                    img: "swa-jacad.png",
                },
                {
                    url: "https://workalove.com",
                    img: "workalove.png",
                },
                {
                    url: 'https://persone.com.br/',
                    img: 'persone.png',
                },
                {
                    url: 'https://educa-insights.com.br/',
                    img: 'educa.png',
                },
            ],
            diferenciais: [
                {
                    titulo:'Programa Completo',
                    descricao: 'Incluindo todas as áreas da gestão universitária.'
                },
                {
                    titulo:'Visão Sistêmica da Gestão Universitária',
                    descricao: 'Não basta contemplar todas as áreas da gestão, é preciso integrá-las. Neste ponto este programa é ímpar, pois consegue relacionar todas as áreas da gestão universitária, dentro de uma mesma linha estratégica.'
                },
                {
                    titulo:'Total Aplicabilidade Prática',
                    descricao: 'O Programa não se limita a ensinar conteúdos, mas atua no desenvolvimento das competências essenciais à consultoria de instituições de ensino.'
                },
                {
                    titulo:'Aprenda com Quem Faz',
                    descricao: 'O programa é ministrado pelo Professor/Consultor Ryon Braga, um dos mais experientes consultores educacionais do país, fundador de várias empresas de consultoria como a Hoper Educação, Atmã Educar e Neoperspectiva Consultoria Educacional, com atuação em mais de 500 instituições de ensino em 5 países.'
                },
                {
                    titulo:'Inovação',
                    descricao: 'O Programa apresenta as mais modernas ferramentas de gestão da era digital e sugere um novo e inédito modelo de se realizar consultorias em instituições de ensino.'
                },
                {
                    titulo:'Networking',
                    descricao: 'O Programa irá permitir a interação com profissionais de diferentes regiões do país, formando um amplo networking.'
                },
                {
                    titulo:'Oportunidade',
                    descricao: 'O Programa irá selecionar os melhores participantes para comporem o quadro de consultores da Neoperspectiva Consultoria Educacional e, também, dará a oportunidade aqueles que quiserem atuar de modo independente, mas em parceria com a Neoperspectiva, usando sua metodologia, ferramentas e assessoria.'
                },
                
            ],
            coordenadores: [
                {
                    nome: 'Ryon Braga',
                    curriculo:'Diretor e Mantenedor da Faculdade Multiversa e presidente da Neoperspectiva Consultoria Educacional. Foi Reitor e mantenedor do Centro Universitário UniAmérica por 9 anos. Sócio-diretor da Atmã Educação e Diretor Técnico da ABMES (Associação Brasileira de Mantenedoras de Ensino Superior). Foi fundador da Hoper Educação, empresa que presidiu por 20 anos e, também, da Multiversa Advisors (empresa de M&A especialidade no segmento educacional). Foi também Diretor Estatutário do Grupo Anima Educação SA e sócio criador do SAGAH – Soluções Educacionais Integradas (maior empresa de produção de conteúdos para EAD, pertencente ao grupo +A Educação). Autor de quatro livros no segmento educacional e consultor para 352 universidades em cinco países: Brasil, Chile, Peru, Paraguai e Colômbia.',
                    image: '/staff/ryon3.jpg',
                    livros: ['/livros/livro-1.jpg', '/livros/livro-2.jpg', '/livros/livro-0.jpg']
                },
            ]
        },
        
        // {
        //     slug: 'mba-em-aprendizagem-evolutiva',
        //     inscricao:'https://portal.multiversa.com/inscricao-pos',
        //     name: 'MBA em Aprendizagem Evolutiva',
        //     img: '/cursos/mba-2.jpg',
        //     area: 'Educação',  
        //     competencias: [],
        //     data_inicio: "09",
        //     mes_inicio: "abril",
        //     ano_inicio: "2022",
        //     carga_horaria:'360 horas/aulas',
        //     duracao: 9,
        //     descricao: '<p>Commodo velit deserunt Lorem incididunt irure incididunt et nulla amet. Ex deserunt Lorem laborum enim nisi excepteur cupidatat excepteur commodo. Dolor elit ex laboris quis. Id ea mollit elit eiusmod occaecat exercitation laborum officia cupidatat reprehenderit adipisicing. Sint ipsum aute magna deserunt sint consectetur qui id reprehenderit ut. Ex eiusmod proident minim velit id irure.</p>',
        //     investimento: [
        //         {
        //             valor: 280,
        //             centavos: 0,
        //             label: '12 parcelas de'
        //         }
        //     ],
        //     matrizes: [
        //         {
        //             titulo: "Compreendendo como acontece o aprendizado",
        //             itens:[
        //                 "Mecanismos neurofisiológicos da aprendizagem",
        //                 "Aprendizagem efetiva",
        //                 "Aprender a aprender"
        //             ]
        //         },
        //         {
        //             titulo: "Modelos Curriculares Inovadores",
        //             itens:[
        //                 "Trabalhabilidade e empregabilidade no século XXI",
        //                 "Integração horizontal e vertical de currículos",
        //                 "Instrumentos Avaliativos Inovadores"
        //             ]
        //         },
        //         {
        //             titulo: "Metodologias Ativas de aprendizagem",
        //             itens:[
        //                 "Princípios da aprendizagem ativa",
        //                 "Tipos de metodologias ativas",
        //                 "Aplicabilidade das metodologias ativas"
        //             ]
        //         },
        //         {
        //             titulo: "Aprendizagem baseada em desafios e projetos",
        //             itens:[
        //                 "Metodologias de projetos",
        //                 "Projetos de escopo fechado e de escopo aberto",
        //                 "Estruturação de desafios de aprendizagem"
        //             ]
        //         },
        //         {
        //             titulo: "Planejamento de atividades de aprendizagem",
        //             itens:[
        //                 "Elaboração de atividades de aprendizagem",
        //                 "Roteirização de atividades de aprendizagem",
        //                 "Atividades baseadas em conteúdo versus atividades baseadas em competências"
        //             ]
        //         },
        //         {
        //             titulo: "Educação Híbrida e o uso da Tecnologia",
        //             itens:[
        //                 "Modelos híbridos de educação",
        //                 "Tecnologias educacionais emergentes",
        //                 "Metodologia para o uso adequado da tecnologia"
        //             ]
        //         },
        //         {
        //             titulo: "Estratégias de engajamento e acompanhamento do estudante",
        //             itens:[
        //                 "Habilidades socioemocionais em contexto educacional",
        //                 "Formas de feedback",
        //                 "Processos motivacionais"
        //             ]
        //         },
        //         {
        //             titulo: "Inteligência Evolutiva",
        //             itens:[
        //                 "Habilidade de discernir",
        //                 "Habilidade de priorizar",
        //                 "Visão sistêmica"
        //             ]
        //         },
        //         {
        //             titulo: "Educação e Aprendizagem Evolutiva",
        //             itens:[
        //                 "Aprender para evoluir",
        //                 "Aprender a evoluir",
        //                 "Educar para evoluir"
        //             ]
        //         },
        //         {
        //             titulo: "O perfil do professor do século XXI",
        //             itens:[
        //                 "Empreendedorismo e gestão de carreira docente na educação superior",
        //                 "Professor Preceptor",
        //                 "Acompanhamento do processo da aprendizagem"
        //             ]
        //         },
        //     ]
        // },
        // {
        //     slug: 'especializacao-em-psico-oncologia',
        //     inscricao:'https://portal.multiversa.com/inscricao-pos',
        //     name: 'Especialização em Psico-oncologia',
        //     img: '/cursos/mba-3.jpg',
        //     area: 'Educação',  
        //     competencias: [],
        
        //     carga_horaria:'360 horas/aulas',
        
        //     descricao: '<p>Occaecat nulla commodo aute dolore enim ipsum enim aute fugiat cupidatat nulla est occaecat dolore. Sint do irure veniam Lorem aliquip cillum ut magna. In nisi minim enim irure et duis dolor qui eiusmod. Consectetur magna sunt nostrud velit. Laboris occaecat Lorem et aliqua dolore.</p>',
        //     investimento: [
        //         {
        //             valor: 280,
        //             centavos: 0,
        //             label: '12 parcelas de'
        //         }
        //     ]
        // },
        // {
        //     slug: "curso-completo",
        //     inscricao:'https://portal.multiversa.com/inscricao-pos',
        //     name: "Curso Completo",
        //     descricao: "<p>Há um grande movimento liderado pelo Ministério do Turismo e com forte investimento da iniciativa privada, que ganha consistência para aumentar o potencial turístico do país, beneficiando toda a cadeia produtiva do setor, onde o caminho traçado é o da inovação. </p>\r\n<p>Os investimentos são em diagnósticos e na implantação de Hubs de Inovação e Ecossistemas Empreendedores (incubadoras, aceleradoras e startups) para promoção de mudanças no turismo, com foco na melhoria da experiência do viajante, agregando valor aos serviços ofertados em toda a cadeia turística.</p>\r\n<p>O Brasil lidera o crescimento de Venture Capital na América Latina, com mais de 12 mil startups ativas e investimentos que superam os R$ 9 bilhões. Neste cenário, o Centro Universitário Uniamérica Descomplica tem expertise, conhecimento e convicção de que pode estimular ainda mais estas iniciativas e ajudar este ecossistema a crescer em todo o país.</p>\r\n<p>Com este propósito, criamos o MBA em Novos Negócios do Turismo e Hotelaria, um programa revolucionário para preparar empreendedores, empresas, organizações e profissionais a criar novos negócios, produtos e serviços, gerar novas soluções, superar desafios de crescimento e consolidar os investimentos no turismo.</p>\r\n<p>No MBA as trilhas de conhecimento levarão os participantes a terem acesso às tendências, inovações e oportunidades do mercado turístico e de hospitalidade e a criar e validar o seu próprio negócio, por meio da metodologia de lean startup, desenvolvendo e testando um produto minimamente viável (MVP). </p>\r\n<p>Este processo será desenvolvido dentro do Espaço Supernova, estimulado e amparado por um ecossistema empreendedor, formado por profissionais especializados e um grupo seleto de mentores, com cases de negócios consolidados no mercado em todo o país. </p>\r\n<p>O Espaço Supernova é o ambiente de inovação da Uniamérica Descomplica e abriga, ainda, a incubadora Santos Dumont, do Polo Tecnológico da Itaipu Binacional (PTI) e empresas incubadas pelo Hackatour (espaço de empreendedorismo do Festival de Turismo das Cataratas), além de conectar startups à ecossistemas empreendedores, à aceleradoras e à investidores de todo o país.</p>\r\n<p>Ao testar o negócio, produto ou serviço, os participantes do MBA terão a oportunidade de modelar e desenvolver o seu Plano de Negócios. O programa é extremamente inovador ao proporcionar aos participantes, ainda, uma imersão no ecossistema empreendedor da região, nos principais equipamentos e atrativos turísticos de Foz do Iguaçu (Segundo destino turístico do Brasil) e a apresentação de um PITCH de 7 minutos a um grupo seleto de investidores.</p>\r\n<p>O Centro Universitário Uniamérica Descomplica entende que inovação é energia positiva que gera transformação e que o turismo é a grande mola propulsora para a recuperação da economia do país.</p>",
        //     img: "/portal-turismo/cursos/novos-negocios.jpg",
        //     categoria: "Pós-graduação",
        //     area: 'Turismo e Hotelaria',
        //     data_inicio: "26",
        //     mes_inicio: "março",
        //     ano_inicio: "2022",
        //     carga_horaria:'360 horas/aulas',
        //     duracao: 8,
        //     competencias:["Desenvolver mindset empreendedor para o turismo","Desenvolver Pesquisa de Mercado no segmento de turismo e hospedagem","Identificar tendências, inovações e oportunidades no mercado turístico","Desenvolver e validar um Produto Mínimamente Viável (MVP)","Desenvolver um Diagnóstico do ecossistema empreendedor do turismo e hotelaria.","Desenvolver inovação e business intelligence","Elaborar o Plano de Negócios e formalizar a empresa","Apresentar um Pitch de 7 minutos para investidores"],
        //     investimento: [{"label": "12 Parcelas de","valor": 420},{"label": "18 Parcelas de","valor": 280}],
        //     matrizes: [
        //         {
        //             titulo: "Compreendendo como acontece o aprendizado",
        //             itens:[
        //                 "Mecanismos neurofisiológicos da aprendizagem",
        //                 "Aprendizagem efetiva",
        //                 "Aprender a aprender"
        //             ]
        //         },
        //         {
        //             titulo: "Modelos Curriculares Inovadores",
        //             itens:[
        //                 "Trabalhabilidade e empregabilidade no século XXI",
        //                 "Integração horizontal e vertical de currículos",
        //                 "Instrumentos Avaliativos Inovadores"
        //             ]
        //         },
        //         {
        //             titulo: "Metodologias Ativas de aprendizagem",
        //             itens:[
        //                 "Princípios da aprendizagem ativa",
        //                 "Tipos de metodologias ativas",
        //                 "Aplicabilidade das metodologias ativas"
        //             ]
        //         },
        //         {
        //             titulo: "Aprendizagem baseada em desafios e projetos",
        //             itens:[
        //                 "Metodologias de projetos",
        //                 "Projetos de escopo fechado e de escopo aberto",
        //                 "Estruturação de desafios de aprendizagem"
        //             ]
        //         },
        //         {
        //             titulo: "Planejamento de atividades de aprendizagem",
        //             itens:[
        //                 "Elaboração de atividades de aprendizagem",
        //                 "Roteirização de atividades de aprendizagem",
        //                 "Atividades baseadas em conteúdo versus atividades baseadas em competências"
        //             ]
        //         },
        //         {
        //             titulo: "Educação Híbrida e o uso da Tecnologia",
        //             itens:[
        //                 "Modelos híbridos de educação",
        //                 "Tecnologias educacionais emergentes",
        //                 "Metodologia para o uso adequado da tecnologia"
        //             ]
        //         },
        //         {
        //             titulo: "Estratégias de engajamento e acompanhamento do estudante",
        //             itens:[
        //                 "Habilidades socioemocionais em contexto educacional",
        //                 "Formas de feedback",
        //                 "Processos motivacionais"
        //             ]
        //         },
        //         {
        //             titulo: "Inteligência Evolutiva",
        //             itens:[
        //                 "Habilidade de discernir",
        //                 "Habilidade de priorizar",
        //                 "Visão sistêmica"
        //             ]
        //         },
        //         {
        //             titulo: "Educação e Aprendizagem Evolutiva",
        //             itens:[
        //                 "Aprender para evoluir",
        //                 "Aprender a evoluir",
        //                 "Educar para evoluir"
        //             ]
        //         },
        //         {
        //             titulo: "O perfil do professor do século XXI",
        //             itens:[
        //                 "Empreendedorismo e gestão de carreira docente na educação superior",
        //                 "Professor Preceptor",
        //                 "Acompanhamento do processo da aprendizagem"
        //             ]
        //         },
        //     ],
        //     parceiros: [
        //         {
        //             url: 'https://uniamerica.br/supernova',
        //             img: 'logo-supernova.svg',
        //         },
        //         {
        //             url: 'https://www.hackatour.com/',
        //             img: 'logo-hackatur.svg',
        //         },
        //         {
        //             url: 'https://idestur.com/',
        //             img: 'logo-idestur.svg',
        //         },
        //         {
        //             url: 'https://festivaldascataratas.com/',
        //             img: 'logo-festival.svg',
        //         },
        //         {
        //             url: 'https://www.desbravador.com.br/',
        //             img: 'logo-desbravador.svg',
        //         },
        //         {
        //             url: 'https://www.grupocataratas.com/',
        //             img: 'logo-cataratas.svg',
        //         },
        //         {
        //             url: 'https://poloiguassu.org/',
        //             img: 'logo-polo-iguassu.svg',
        //         },
        //     ],
        //     professores:[
        //         {
        //             "curriculo": "Mestre pela UFRGS e doutorando em Administração (FGV EAESP). É diretor para o Brasil do Wakalua, fundador da Numerik (www.numerik.co), consultoria de inovação aberta e estratégia. Integra a Câmara do Turismo 4.0, e trabalha junto ao Ministério do Turismo e o Ministério da Ciência, Tecnologia e Inovaões para o avanço do ecossistema turistech no país.",
        //             "image": "/staff/eduardo-lorea.jpg",
        //             "nome": "Eduardo Lorea"
        //         },
        //         {
        //             "curriculo": "Economista pela UNESP, especialista em Marketing Turístico pelo Senac, tem MBA em Marketing Estratégico e Mestre em Ciências da Comunicação e Turismo pela USP. Realiza diversas palestras, webinars, consultorias e cursos na área de Marketing Digital, Mídias Sociais, Tendências, Inovação e Transformação Digital no Turismo",
        //             "image": "/staff/marta-poggi.jpg",
        //             "nome": "Marta Poggi"
        //         },
        //         {
        //             "curriculo": "Administrador, Diretor Executivo do Grupo Cataratas em Foz do Iguaçu, possui mais de 25 anos de experiência em gestão de hotelaria e atrativos turísticos, principalmente em unidade de conservação. Participou da implantação das operações da Cataratas do Iguaçu S.A no Parque Nacional do Iguaçu e no Marco das Três Fronteiras.",
        //             "image": "/staff/adelio-demeterko.jpg",
        //             "nome": "Adelio Demeterko"
        //         },
        //         {
        //             "curriculo": "Idealizador e organizador do Festival das Cataratas e do Hackatour, presidente do IDESTUR e atual Secretário de Turismo, Projetos Estratégicos e Inovação de Foz do Iguaçu",
        //             "image": "/staff/paulo-angeli.jpg",
        //             "nome": "Paulo Angeli"
        //         },
        //         {
        //             "curriculo": "Atuou como Secretário Nacional de Desenvolvimento e Competitividade do Turismo (SNDTur), do Ministério do Turismo. Bacharel em Comunicação Social – Jornalismo pelo UniCEUB e especialização em Gestão Estratégica pela FGV. Atuou como analista legislativo da Câmara do Deputados e Diretor da Secretaria de Comunicação Social da Câmara.",
        //             "image": "/staff/william-franca.jpg",
        //             "nome": "William França Cordeiro"
        //         }
        //     ],
        //     diferenciais: [
        //         {
        //             "descricao": " A cada trilha o aluno aplica seu projeto à sua realidade profissional",
        //             "titulo": "Máxima aplicabilidade",
        //             "icon": "lightbulb"
        //         },
        //         {
        //             "descricao": "Momentos imersivos em Foz do Iguaçu para que você possa vivenciar no nível máximo a experiência",
        //             "titulo": "Encontro Imersivo (opcional)",
        //             "icon": "lightbulb"
        //         },
        //         {
        //             "descricao": " Master Class ao vivo com pessoas que são autoridades em inovação em turismo",
        //             "titulo": "Master Class com especialistas",
        //             "icon": "lightbulb"
        //         },
        //         {
        //             "descricao": " Acompanhamento e feedback personalizado com docentes experientes, garantindo o melhor aproveitamento por parte do aluno",
        //             "titulo": "Preceptoria",
        //             "icon": "lightbulb"
        //         },
        //         {
        //             "descricao": " Assessoria de tutor para organização e suporte técnico nos processos do curso",
        //             "titulo": "Assessoramento individual",
        //             "icon": "lightbulb"
        //         },
        //         {
        //             "descricao": "Certificados de competências ao longo do curso, enriquecendo seu currículo antes mesmo de concluir todo o MBA",
        //             "titulo": "Nano degree (Certificados Parciais)",
        //             "icon": "lightbulb"
        //         },
        //         {
        //             "descricao": " Todos os projetos aplicados durante o curso consideram as necessidades do contexto profissional do aluno",
        //             "titulo": "Aprendizagem personalizada",
        //             "icon": "lightbulb"
        //         },
        //         {
        //             "descricao": "Negócios criados pelos participantes do MBA receberão mentoria e serão incubados no Supernova, espaço de empreendedorismo e inovação da Uniamérica Descomplica.",
        //             "titulo": "Parcerias com Incubadoras e Aceleradoras",
        //             "icon": "lightbulb"
        //         },
        //         {
        //             "descricao": "Oportunidade de participar de workshops e visitas técnicas com foco nos modelos de negócios, nos âmbitos estratégicos e táticos, de estruturas como a Itaipu Binacional, Cataratas S/A e outras",
        //             "titulo": "Visitas técnicas",
        //             "icon": "lightbulb"
        //         },
        //         {
        //             "descricao": "Os alunos terão a oportunidade de participar do Festival de Turismo das Cataratas, segundo maior evento do turismo brasileiro",
        //             "titulo": "Participação em Eventos",
        //             "icon": "lightbulb"
        //         },
        //         {
        //             "descricao": "Os participantes terão a oportunidade de apresentar um PITCH de 7 minutos a um grupo seleto de investidores",
        //             "titulo": "Captação de Investimentos",
        //             "icon": "lightbulb"
        //         }
        //     ]
        // },
    ]
    export default cursos;